import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import styles from './Modal.module.css';

const Modal = ({ isOpen, onClose, children, showNotch = true, showClose = true }) => {
  const [shouldRender, setShouldRender] = useState(isOpen);
  const [isClosing, setIsClosing] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setShouldRender(true);
      document.body.style.overflow = 'hidden';
    } else if (shouldRender) {
      setIsClosing(true);
      const timer = setTimeout(() => {
        setShouldRender(false);
        setIsClosing(false);
      }, 300);

      return () => clearTimeout(timer);
    }
  }, [isOpen]);

  useEffect(() => {
    const escHandler = (e) => {
      if (e.key === 'Escape') handleClose();
    };
    document.addEventListener('keydown', escHandler);
    return () => document.removeEventListener('keydown', escHandler);
  }, []);

  const handleClose = () => {
    setIsClosing(true);
    document.body.style.overflow = 'auto';
    setTimeout(() => {
      setShouldRender(false);
      setIsClosing(false);
      onClose();
    }, 300);
  };

  if (!shouldRender) return null;

  // Body par portal — kisi transform wale parent (page slide) ke andar
  // iOS Safari par fixed backdrop poori screen nahi dhakta aur blur nahi lagta.
  return createPortal(
    <div className={styles.backdrop} >
      <div
        className={`${styles.modalContainer} ${isClosing ? styles.slideDown : ''}`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className={styles.modal}>
          {showClose && (
            <button className={styles.closeBtn} onClick={handleClose}>
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10 0C4.478 0 0 4.478 0 10C0 15.522 4.478 20 10 20C15.522 20 20 15.522 20 10C20 4.478 15.522 0 10 0ZM15.166 14.034C15.478 14.3462 15.478 14.854 15.166 15.166C15.01 15.322 14.804 15.4 14.6 15.4C14.396 15.4 14.19 15.322 14.034 15.166L10 11.132L5.966 15.166C5.81 15.322 5.604 15.4 5.4 15.4C5.196 15.4 4.99 15.322 4.834 15.166C4.522 14.8538 4.522 14.346 4.834 14.034L8.868 10L4.834 5.966C4.522 5.654 4.522 5.146 4.834 4.834C5.146 4.522 5.654 4.522 5.966 4.834L10 8.868L14.034 4.834C14.3462 4.522 14.854 4.522 15.166 4.834C15.478 5.146 15.478 5.654 15.166 5.966L11.132 10L15.166 14.034Z" fill="#5D5D5D" />
              </svg>

            </button>
          )}
          {children}
        </div>
        {showNotch && <div className={styles.notch}></div>}
      </div>
    </div>,
    document.body
  );
};

export default Modal;
